<!-- 逾期明细表 -->
<!-- eslint-disable vue/no-unused-refs -->
<template>
  <div>
    <!-- 搜索区 -->
    <!--  eslint-disable-next-line vue/no-unused-refs -->
    <el-form class="mt16" :model="searchData" :rules="rules" ref="search">
      <QS-search maxLine="2">
        <el-form-item prop="receivableId" label="应收ID">
          <el-input
            v-number:integer
            v-model="searchData.receivableId"
            placeholder="请输入应收ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="车牌号">
          <el-select
            v-model="searchData.carId"
            filterable
            remote
            reserve-keyword
            clearable
            placeholder="请输入"
            :remote-method="
              query => {
                loadPlateNoData(query)
              }
            "
            :loading="oLoading.fuzzy"
            @visible-change="
              e => {
                changeValue(e)
              }
            "
          >
            <el-option
              v-for="item in plateNoData"
              :key="'options' + item.id"
              :label="item.plateNo"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户来源" prop="customerType">
          <el-select
            v-model="searchData.customerType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in customerTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-select
            v-model="searchData.customerId"
            filterable
            clearable
            remote
            placeholder="请输入"
            :remote-method="loadNameData"
            :loading="oLoading.fuzzySearch"
            @visible-change="
              e => {
                changeValue(e, 'customerManage')
              }
            "
          >
            <el-option
              v-for="item in curstomerNameData"
              :key="item.id"
              :label="`${item.customerName} ${item.customerTel || ''}`"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="逾期阶段" prop="overDueLevel">
          <template slot="label">
            <span
              >逾期阶段
              <el-tooltip placement="right">
                <div slot="content">
                  轻度逾期：1-9天<br />
                  中度逾期：10-15天<br />
                  重度逾期：>=16天<br />
                  逾期区间值可在【逾期配置】中调整
                </div>
                <i class="QS-icon-info"></i> </el-tooltip
            ></span>
          </template>
          <el-select
            v-model="searchData.overDueLevel"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in overDueLevelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟进状态" prop="followState">
          <el-select
            v-model="searchData.followState"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in followStateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应收日期">
          <el-date-picker
            v-model="dateRange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="还款状态">
          <el-select
            clearable
            placeholder="请选择还款状态"
            v-model="searchData.finishState"
          >
            <el-option
              v-for="item in receivableStateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <CarBrandSeriesModel
          ref="carBrandSeriesModelRef"
          v-model="brandSeriesModel"
          :showModel="true"
          :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
          ></CarBrandSeriesModel>

        <el-form-item label="租赁状态">
          <!-- 多选状态下使用 collapse-tags 否则会有界面bug -->
          <el-select
            clearable
            placeholder="请选择租赁状态"
            v-model="searchData.orderStateList"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in leaseStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
          <el-form-item>
            <!-- <export
              :exportTemplate="exportTemplate"
              filename="逾期明细.xlsx"
              :params="exportParams"
              v-if="judgePermission('overdueExport')"
            ></export> -->
            <el-button
              v-if="
                judgePermission('under_lease_over_due_hasten_debt_list_export')
              "
              :loading="oLoading.export"
              @click="asycnExportHandle"
            >
              导出数据
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="
                judgePermission('under_lease_over_due_hasten_debt_list_export')
              "
              @click="exportDataHandle"
            >
              导出列表
            </el-button>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>

    <!-- 列表 -->
    <QS-common-table
      :loading="oLoading.search"
      :data="tableData"
      :columns="columns"
      :pagination="paginationData"
      @change="paginationChange"
    >
      <template slot="operation-group">
        <el-button
          v-if="judgePermission('under_lease_over_due_hasten_debt_list_config')"
          type="primary"
          @click="configHandle"
          >逾期配置</el-button
        >
      </template>
    </QS-common-table>
    <!-- 逾期配置 -->
    <config-dialog
      v-if="configDialogObj.dialogVisible"
      :dialogVisible="configDialogObj.dialogVisible"
      @close="configDialogObj.dialogVisible = false"
      @refresh="searchHandle"
    />

    <!-- 导出列表 -->
    <export-list-dialog
      v-if="dialogObj.visible"
      :dialogVisible="dialogObj.visible"
      @close="dialogObj.visible = false"
    />

    <!-- 跟进 -->
    <follow-dialog
      v-if="followDialogObj.visible"
      :dialogVisible="followDialogObj.visible"
      :receivableId="followDialogObj.data"
      @close="followDialogObj.visible = false"
      @refresh="searchHandle"
    />
  </div>
</template>
<script>
import { parseQueryJsonStr } from '@/utils/querySchema'
import config from '../config/detailList/overdueDetailList'
import { getOverDueItems, asyncOverdueExport } from '@/api/domain/orders'
import Mixin from '../mixins'
import configDialog from './configDialog.vue'
import exportListDialog from './exportListDialog.vue'
import followDialog from './followDialog.vue'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

const mixin = Mixin({
  getListFn: getOverDueItems,
  searchData: {
    receivableId: '', // 应收ID
    carId: '', // 车牌号
    customerType: '', // 客户来源（类型）
    customerName: '', // 客户名称
    customerId: '', // 客户ID
    overDueLevel: '', // 逾期阶段
    followState: '', // 跟进状态
    startDate: '', // 开始时间
    endDate: '', // 结束时间
    finishState: '', // 还款状态
    orderStateList: [], // 租赁状态
  },
  exportTemplate: 'Overdue',
})
export default {
  mixins: [mixin],
  components: {
    configDialog,
    exportListDialog,
    followDialog,
  },
  data() {
    const { query: queryStr } = this.$route?.query
    const queryObj = queryStr ? parseQueryJsonStr(queryStr) : {}

    const {
      columns,
      rules,
      customerTypeOptions,
      overDueLevelOptions,
      receivableStateOptions,
      leaseStatusOptions,
      followStateOptions,
    } = config.call(this)
    return {
      columns,
      rules,
      customerTypeOptions,
      overDueLevelOptions,
      receivableStateOptions,
      leaseStatusOptions,
      followStateOptions,
      configDialogObj: {
        dialogVisible: false,
      },
      followDialogObj: {
        visible: false,
        data: null,
      },
      queries: queryObj,
      brandSeriesModel: {},
      CAR_MODEL_FILTER_SCENE,
    }
  },
  created() {
    this.getRouteQuery()
  },
  methods: {
    getRouteQuery() {
      const { search = {} } = this.queries
      const {
        dateRange = '',
        customerType = '',
        overDueLevel = '',
        finishState = '',
        followState = '',
      } = search

      if (dateRange !== '') {
        this.dateRange = dateRange
      }
      if (customerType !== '') {
        this.searchData.customerType = customerType
      }
      if (overDueLevel !== '') {
        this.searchData.overDueLevel = overDueLevel
      }
      if (finishState !== '') {
        this.searchData.finishState = finishState
      }
      if (followState !== '') {
        this.searchData.followState = followState
      }
      // 跟进状态（新增）
    },
    // 逾期配置
    configHandle() {
      this.configDialogObj.dialogVisible = true
    },
    // 导出列表
    exportDataHandle() {
      this.dialogObj = {
        visible: true,
        title: '导出列表',
      }
    },
    // 异步导出数据
    async asycnExportHandle() {
      this.oLoading.export = true
      try {
        const { code } = await asyncOverdueExport(this.exportParams)
        if (code === 1) {
          this.$message.success(
            '所选数据已生成下载文件，请点击【导出列表】查看下载',
          )
        }
        this.oLoading.export = false
      } catch (error) {
        this.oLoading.export = false
      }
    },
    // 跟进
    // eslint-disable-next-line vue/no-unused-properties
    followHandle(row) {
      this.followDialogObj.visible = true
      this.followDialogObj.data = row.id
    },
    // 逾期详情
    // eslint-disable-next-line vue/no-unused-properties
    overdueDetailHandle(row) {
      this.$router.push({
        path: '/underLease/overdue/detailList/detail',
        query: {
          overdueId: row.id,
        },
      })
    },
    // 逾期收款
    // eslint-disable-next-line vue/no-unused-properties
    overdueHandle(row) {
      this.$router.push({
        path: '/finance/AddCollection',
        query: {
          paymentIds: row.receivableId,
          type: 'overdue',
          overdueId: row.id,
          approvalOrigin: 8,
        },
      })
    },
  },
}
</script>
<style scoped lang="scss">
.customer {
  display: flex;
  flex-direction: row;
  &-name {
    width: 100px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-phone {
    color: #8492a6;
    font-size: 13px;
    padding-left: 20px;
  }
}
</style>
